import React, { useCallback, useRef, useState } from 'react';
import { SelectValue } from 'antd/lib/select';
import debounce from 'lodash/debounce';
import { Select } from 'antd';
import Spin from 'antd/es/spin';

interface SelectItem {
  value: string,
  text: string,
  component?: React.ReactNode,
  payload?: any
}

export interface CustomSelectProps {
  onChange: (val: SelectValue) => void,
  onSearch: (search: string) => Promise<Array<SelectItem | any>>,
  value?: SelectValue,
  pause?: number,
  onSelect?: (value: SelectValue) => void,
  loadOnFocus?: boolean,
  [key: string]: any
}

function CustomSelect({
  onSearch, onChange, value, pause = 800, onSelect, loadOnFocus, ...rest
}: CustomSelectProps) {
  const selectRef = useRef<null | Select>(null);

  const [results, setResults] = useState<Array<SelectItem>>([]);
  const [fetching, setFetching] = useState(false);
  const search = useCallback(
    (val: string) => {
      console.debug('search', val, fetching);
      if (!fetching) {
        setFetching(true);
        setResults([]);
        onSearch(val).then(
          (res) => {
            setFetching(false);
            setResults(res);
          },
          () => setFetching(false),
        );
      }
    },
    [onSearch, fetching],
  );

  const handleSelect = (val: SelectValue) => {
    if (onSelect) onSelect(val);
    setResults([]);
  };

  const handleSearch = useCallback(
    debounce(search, pause),
    [search],
  );

  const handleFocus = useCallback(
    () => {
      if (loadOnFocus) search('');
      // @ts-ignore
      // if (typeof selectRef.current?.rcSelect?.setInputValue === 'function' && value) selectRef.current.rcSelect.setInputValue(value);
    },
    [selectRef, value, loadOnFocus, search],
  );

  return (
    <Select
      {...rest}
      value={value || undefined}
      notFoundContent={fetching ? <Spin size="small" /> : 'Не найдено'}
      onChange={onChange}
      onSelect={handleSelect}
      onSearch={handleSearch}
      defaultActiveFirstOption={false}
      filterOption={false}
      showArrow={false}
      showSearch
      allowClear
      onFocus={handleFocus}
      autoClearSearchValue
      ref={selectRef}
      onBlur={() => setResults([])}
    >
      {results.map((res) => <Select.Option key={res.value}>{res.component ? res.component : res.text}</Select.Option>)}
    </Select>
  );
}

export default CustomSelect;
